import WorkImage from "../components/WorkImage";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG, WORK_CATEGORIES, WORK_PROJECTS } from "../data/content";
import { FadeUp, Overline } from "../components/Reveal";
import { CTASection, PageHero } from "../components/PageHero";

export default function Work() {
  const [cat, setCat] = useState("All");
  const availableCats = WORK_CATEGORIES.filter((c) => c === "All" || WORK_PROJECTS.some((p) => p.category === c));
  const shown = cat === "All" ? WORK_PROJECTS : WORK_PROJECTS.filter((p) => p.category === cat);

  return (
    <main data-testid="work-page">
      <PageHero
        overline="Our Work"
        lines={["From ideas", "to execution"]}
        desc="A glimpse of GrowMyRestro projects across marketing, content, branding, events, interiors and uniforms."
        img="/photo-social-team.jpg"
        imgAlt="A creative team planning social media campaigns"
        accent="#D97706"
      />
      <section className="hospitality-background py-12 sm:py-16 lg:py-20 relative overflow-hidden">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
          <FadeUp className="flex flex-wrap gap-2.5" data-testid="work-filters">
            {availableCats.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`work-filter-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm font-semibold border transition-all duration-300 ${
                  cat === c ? "bg-aubergine text-cream border-aubergine" : "bg-white text-aubergine border-line hover:border-saffron"
                }`}
              >
                {c}
              </button>
            ))}
          </FadeUp>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-8 sm:mt-10" data-testid="work-grid">
            {shown.map((p, i) => (
              <FadeUp key={p.name} delay={i * 0.06}>
                <div className="hospitality-card group h-full flex flex-col bg-white rounded-[2rem] overflow-hidden border border-line hover:-translate-y-1.5 hover:shadow-[0_28px_70px_rgba(45,18,77,0.12)] transition-all duration-300" data-testid={`work-card-${p.name.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                  <div className="relative aspect-[4/3] shrink-0 overflow-hidden">
                    <WorkImage project={p} />
                    <span className="absolute top-4 left-4 right-4 w-fit max-w-[calc(100%-2rem)] bg-cream/90 backdrop-blur text-[11px] font-mono uppercase tracking-[0.15em] text-aubergine px-3 py-1.5 rounded-full">{p.category}</span>
                  </div>
                  <div className="p-6">
                    <h3 className="font-display font-bold text-lg text-aubergine">{p.name}</h3>
                    <p className="mt-1.5 text-sm text-ink-muted leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
          {shown.length === 0 && (
            <p className="mt-8 sm:mt-10 text-center text-ink-muted" data-testid="work-empty">Projects in this category coming soon.</p>
          )}
          <FadeUp className="mt-8 sm:mt-10 text-center">
            <Link to="/contact" data-testid="work-cta-button" className="group inline-flex items-center gap-2 bg-aubergine text-cream font-bold px-7 py-3.5 rounded-full hover:bg-saffron hover:text-aubergine-deep transition-colors duration-300">
              Start your project <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </FadeUp>
        </div>
      </section>
      <CTASection
        title="Your project could be next"
        sub="From a single photoshoot to a complete 360° growth plan — let's talk about what your business needs."
      />
    </main>
  );
}
